import Component from '../inherited/Component'

export default class SlidingMenu extends Component {
    constructor (elem, theme, options, ctx) {
        super(elem, theme, options, ctx)
        this._slidingArea = this._elem.querySelector('[data-moving-container]')
        this._navItems = this._elem.querySelectorAll('[data-nav-item]')
        this._width = this._elem.getBoundingClientRect().width
        this._height = this._elem.getBoundingClientRect().height
        this._currentLevel = 1
    }

    mount () {
        for (let navItem of this._navItems) {
            let navLinks = navItem.querySelectorAll('[data-level]')
            for (let link of navLinks) {
                let linkLevel = parseInt(link.dataset.level)
                let menuArea = link.dataset.menuArea
                link.addEventListener('click', (e) => {
                    e.preventDefault()
                    if (menuArea) {
                        this.showMenu(linkLevel, menuArea)
                    }
                    this.goToLevel(linkLevel)
                })
            }
        }

        let firstItem = this._navItems[0].querySelector('[data-menu-area]')
        this.setWidths()
        this.setHeight(firstItem)

        window.addEventListener('resize', e => {
            this.setWidths()
            this.goToLevel(this._currentLevel)
        }, { passive: true })
    }

    setWidths () {
        this._width = this._elem.getBoundingClientRect().width
        this._slidingArea.style.minWidth = `${this._width * 3}px`
        for (let navItem of this._navItems) {
            navItem.style.width = `${this._width}px`
        }
    }

    setHeight (elem = this._elem) {
        this._height = elem.getBoundingClientRect().height
        this._slidingArea.style.height = `${this._height}px`
    }

    showMenu (level, menuHandle) {
        let toHide = this._elem.querySelectorAll(`[data-nav-item='${level}'] > nav`)
        let toShow = this._elem.querySelector(`[data-nav-item='${level}'] [data-menu-area='${menuHandle}']`)
        for (let navItem of toHide) {
            navItem.classList.add('hide')
        }
        toShow.classList.remove('hide')
        this.setHeight(toShow)
    }

    goToLevel (level) {
        this._currentLevel = level

        for (let navItem of this._navItems) {
            navItem.classList.remove('shown')
        }
        if (this._navItems[level - 1]) {
            this._navItems[level - 1].classList.add('shown')
        }

        let activeMenuArea = this._navItems[level - 1].querySelector(`nav[data-menu-area]:not(.hide)`)
        this.setHeight(activeMenuArea)

        this._elem.scrollTo(0, 0)



        let transformAmount = 0 - ((level - 1) * this._width)

        if (document.documentElement.dir === 'rtl') {
          transformAmount *= -1
        }

        let transform = `translateX(${transformAmount}px)`
        this._slidingArea.style.webkitTransform = transform
        this._slidingArea.style.MozTransform = transform
        this._slidingArea.style.msTransform = transform
        this._slidingArea.style.OTransform = transform
        this._slidingArea.style.transform = transform
    }

    reset () {
        this.goToLevel(1)
    }
}